//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Input from './Input';

export default {
    extends: Input,
};
